const TASK_TITLE_KEYS = {
  'shift handover': 'shiftHandover',
  'progress note': 'progressNote',
  'fluid balance': 'fluidBalance',
  vitals: 'vitals',
  medications: 'medications',
  'patient repositioning': 'taskPatientRepositioning',
  'neurological assessment': 'taskNeurologicalAssessment',
  'blood sugar monitoring': 'taskBloodSugarMonitoring',
  'wound site assessment': 'taskWoundSiteAssessment',
  'pain assessment': 'taskPainAssessment',
  'pain assessment (flacc/wong-baker)': 'taskPainAssessmentPediatric',
  'drain output check': 'taskDrainOutputCheck',
  'growth and development check': 'taskGrowthDevelopmentCheck',
  'parent/guardian update': 'taskParentGuardianUpdate',
  'fetal heart rate monitoring': 'taskFetalHeartRateMonitoring',
  'fundal height assessment': 'taskFundalHeightAssessment',
  'lochia assessment': 'taskLochiaAssessment',
  'breastfeeding support': 'taskBreastfeedingSupport',
  'newborn assessment': 'taskNewbornAssessment',
};

const ITEM_LABEL_KEYS = {
  'blood pressure': 'bloodPressure',
  medication: 'medication',
  'progress note': 'progressNote',
};

const FREQUENCY_KEYS = {
  weekly: 'freqWeekly',
  bid: 'freqBid',
  tid: 'freqTid',
  od: 'freqOd',
  qd: 'freqOd',
  daily: 'freqDaily',
  'q4h': 'freqQ4h',
  'q6h': 'freqQ6h',
  'q6h prn': 'freqQ6hPrn',
  'q8h': 'freqQ8h',
  prn: 'freqPrn',
};

function normalizeKey(value) {
  return String(value || '').trim().toLowerCase();
}

export function translateSex(t, sex) {
  const key = normalizeKey(sex);
  if (key === 'male') return t('male');
  if (key === 'female') return t('female');
  return sex;
}

export function translateTaskTitle(t, title) {
  const raw = String(title || '').trim();
  if (!raw) return raw;
  const key = TASK_TITLE_KEYS[normalizeKey(raw)];
  return key ? t(key) : raw;
}

export function translateTaskItemLabel(t, itemLabel) {
  const raw = String(itemLabel || '').trim();
  if (!raw) return raw;

  const exactKey = ITEM_LABEL_KEYS[normalizeKey(raw)];
  if (exactKey) return t(exactKey);

  return raw.replace(/\bunits\b/gi, t('units'));
}

export function translateMedicationFrequency(t, frequency) {
  const raw = String(frequency || '').trim();
  if (!raw) return raw;

  const directKey = FREQUENCY_KEYS[normalizeKey(raw)];
  if (directKey) return t(directKey);

  const withoutPrn = raw.replace(/\s*PRN\s*/i, '').trim();
  const baseKey = FREQUENCY_KEYS[normalizeKey(withoutPrn)];
  if (baseKey && /\bPRN\b/i.test(raw)) {
    return `${t(baseKey)} ${t('freqPrnSuffix')}`;
  }

  return raw;
}
